import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-conditional-conversion',
  templateUrl: './conditional-conversion.component.html',
  styleUrls: ['./conditional-conversion.component.css']
})
export class ConditionalConversionComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();

  loading: boolean = false;

  dataItem: any = {
    chart: {
      showpercentvalues: "1",
      aligncaptionwithcanvas: "0",
      captionpadding: "0",
      decimals: "0",
      plottooltext:
        "<b>$label</b> - $percentValue",
      centerlabel: "<b>$label</b><br/> $percentValue",
      theme: "gammel",
      palettecolors: "6B48FF, E14D57"
    },
    data: [
      {
        label: "Vendas",
        value: 0,
      },
      {
        label: "Devoluções",
        value: 0,
      },
    ]
  };

  width = "100%";
  height = "320";
  type = "doughnut2d";
  dataFormat = "json";
  dataSource = this.dataItem;
  errorApi: boolean = false;
  message: string = "";

  typeSelected: any = 0;

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  filterItem(item: any) {
    if (item.branch != undefined) {
      this.loading = true;
      let excelInfo: any[] = [];
      this.salesReturnsApi(item).subscribe((data: any) => {
        this.dataItem.data[0].value = data.convertedPercent;
        this.dataItem.data[1].value = data.devolutionPercent;
        excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Vendas': data.convertedPercent + '%', 'Devoluções': data.devolutionPercent + '%'});
        excelInfo.unshift({});
        localStorage.setItem('conditional-conversion-sellers', JSON.stringify(excelInfo));
        this.loading = false;
        this.errorApi = false;
      },
      (error) => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_CONDITIONAL_CONVERSION;
        this.formatErrorMensagem(error.message);
      }); 
    }
  }

  salesReturnsApi(item: any) {
    return this.api.postConditionalRateSellerPanel(item.branch);
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataConditionalConversion = [];
    let objectConditionalConversion = localStorage.getItem('conditional-conversion-sellers');

    objectConditionalConversion != null
      ? (dataConditionalConversion = JSON.parse(objectConditionalConversion))
      : (dataConditionalConversion = []);
    const worksheetConditionalConversion= XLSX.utils.json_to_sheet(dataConditionalConversion);

    const workbook = {
      Sheets: {
        'conditional-conversion': worksheetConditionalConversion,
      },
      SheetNames: [
        'conditional-conversion',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-conditional-conversion' + EXCEL_EXTENSION);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: conditional-conversion \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
